jQuery(document).ready(commonInit);

function commonInit(){
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupLogin();
	setupModals();
	setupHubspotChatLinks(1);
	addHoverClass();
	setupScrollTriggers();
	setupScrollEvents();
	checkTop();
	video_button();
	setupPricingToggle();
	//setupAnchorAnimation();
	
}
 
 


function addHoverClass(){
	
	jQuery('#menu-main-nav > li.menu-item-has-children').hover(
		   function(){ jQuery('body').addClass('hide-banner') },
		   function(){ jQuery('body').removeClass('hide-banner') }
	)
	
}


function setupMobileMenu(){
	
	jQuery("#mobile-nav").mmenu({

	}, {

		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
			
		}
		
	});
	
}

function setupColumns(){
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupLogin() {
	
	jQuery('li.login > a, a.login').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="login"]').remodal().open();
		
	});
	
	if(getUrlVars()['login-failed']) {
		jQuery('div[data-remodal-id="login"]').remodal().open();
	}
	
	if(getUrlVars()['password-reset']) {
		jQuery('div[data-remodal-id="login"]').remodal().open();
		jQuery("#product-login").hide();
		jQuery("#product-recover-password").show();
	}
	
	jQuery("#forgot-password").on("click", function(){
		jQuery("#product-login").hide();
		jQuery("#product-recover-password").show();
	});
	
	jQuery("#back-to-login").on("click", function(){
		jQuery("#product-login").show();
		jQuery("#product-recover-password").hide();
	});
	
}

function setupModals() {
	
	jQuery('li.demo > a, a.demo').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="demo"]').remodal().open();
		
	});
	
	jQuery('li.enterprise-demo > a, a.enterprise-demo').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="enterprise-demo"]').remodal().open();
		
	});
	
	jQuery('div.remodal[data-remodal-id^="general-"] button.remodal-close').on('click', function(){
		
		var current = jQuery(this);
		var modalID = current.parent().attr("data-remodal-id");
		
		sessionStorage.setItem("has-closed-modal-"+modalID, "true");
		
	});
	
	jQuery('li.choose-industry > a, a.choose-industry').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="choose-industry"]').remodal().open();
		
	});
	jQuery('a.choose-industry-2').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="choose-industry-2"]').remodal().open();
		
	});
	jQuery('li.contact-sales > a, a.contact-sales').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="contact-sales"]').remodal().open();
		
	});
	jQuery('li.contact-sales-enterprise > a, a.contact-sales-enterprise').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="contact-sales-enterprise"]').remodal().open();
		
	});
	jQuery('#fetch li.choose-industry > a, #fetch a.choose-industry').on('click', function(e){
		
		e.preventDefault();
		
		jQuery('div[data-remodal-id="get-started-fetch"]').remodal().open();
		
	});
	jQuery('#our-data a.our-data').on('click', function(e){
		  
		  e.preventDefault();
		  
		  jQuery('div[data-remodal-id="our-data"]').remodal().open();
		  
	});
	
	jQuery('#pricing-2 .under-video-content a').on('click', function(e){
		  
		  e.preventDefault();
		  
		  jQuery('div[data-remodal-id="pricing-free-demo"]').remodal().open();
		  
	});
	
	jQuery(' a.ambassador').on('click', function(e){
		  
		  e.preventDefault();
		  
		  jQuery('div[data-remodal-id="ambassador"]').remodal().open();
		  
	}); 

	 

}

function setupAnchorAnimation() {
	
	var hash = window.location.hash;
	
	if(jQuery(hash).length) {
		jQuery('html, body').animate({scrollTop: jQuery(hash).position().top}, 'slow');
	}
	
}

function getUrlVars(){
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

function setupHubspotChatLinks(counter) {
	
	var hasHubspotChat = jQuery('#hubspot-messages-iframe-container').length;
	
	if(hasHubspotChat) {
		
		jQuery('#utility-nav li.chat').show();
		
		jQuery('#utility-nav li.chat > a').on('click', function(){
			window.HubSpotConversations.widget.open();
		});
	
	} else {
		
		jQuery('#utility-nav li.chat').hide();
		
		counter++;
		
		if(counter <= 5) {
			
			setTimeout(function(){
				setupHubspotChatLinks(counter);
			}, 1000);
		
		}
		
	}
	
}

function setupScrollTriggers(){

	const elements = document.querySelectorAll('.scroll-alert:not(.set-up)');
	
	if ('IntersectionObserver' in window) {
	
		const options = {
			root: null,
			rootMargin: '0px 0px -15% 0px',
			threshold: 0
		};
		
		var observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if(entry.isIntersecting) {
					entry.target.classList.add('active');
				}
			});
		}, options);
		
		elements.forEach(element => {
			element.classList.add('set-up');
			observer.observe(element);
		});
		
	} else {
		
		for(var i=0; i<elements.length; i++) {
			elements[i].classList.add('set-up');
			elements[i].classList.add('active');	
		}
		
	}

}

function setupScrollEvents() {
	
	jQuery(window).on('scroll', checkTop);
	
	checkTop();
	
}

function checkTop() {
	
	var offset = jQuery(window).scrollTop();
	var html = jQuery('html');
	
	if(offset > 100) {
		html.addClass('not-top');
	} else {
		html.removeClass('not-top');
	}
	
}

function setupPricingToggle(){
		
	 jQuery(".tab-menu > li:eq(0), .tab-content > div:eq(0)").addClass("active").show();
	   
	   jQuery(".tab-menu > li").click(function(){
		   
		   var menuItem = jQuery(this);
		   
		   menuItem.siblings(".active").removeClass("active");
		   menuItem.addClass("active");
		   
		   var index = menuItem.index();
		   
		   jQuery(".tab-content > .active").removeClass("active").hide();
		   jQuery(".tab-content > div:eq("+index+")").addClass("active").show();
		   
	   });
	 
}





function video_button(){
	jQuery('.modal-youtube').modalVideo();
	jQuery('.modal-vimeo').modalVideo({channel:'vimeo'});
}